import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import { isEmpty } from 'lodash';
let JSONReader = class JSONReader extends Vue {
    constructor() {
        super(...arguments);
        this.fileReader = new FileReader();
        this.filename = '';
        this.characterText = '';
        this.isEmpty = isEmpty;
        this.myFile = [];
    }
    created() {
        this.fileReader.onload = (e) => {
            this.characterText = this.fileReader.result;
        };
    }
    get character() {
        try {
            return JSON.parse(this.characterText);
        }
        catch (e) {
            return {};
        }
    }
    get hasNoCharacter() {
        return isEmpty(this.character);
    }
    handleUpload(newFile) {
        if (newFile) {
            this.filename = newFile.name;
            this.fileReader.readAsText(newFile);
        }
        else
            this.resetValues();
    }
    handleLoad() {
        this.$emit('import', this.character, this.filename);
        this.$emit('input', false);
    }
    resetValues() {
        this.characterText = '';
        this.filename = '';
    }
};
__decorate([
    Prop(Boolean)
], JSONReader.prototype, "value", void 0);
__decorate([
    Watch('value')
], JSONReader.prototype, "resetValues", null);
JSONReader = __decorate([
    Component({
        components: {
            MyDialog
        }
    })
], JSONReader);
export default JSONReader;
